import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Report from './Report';
import Notifications from './Notifications';
import { Sections } from '../../Components/Containers/Section';
import Icon from '../../Components/Icons/Icon';
import { Link } from 'react-router-dom';

const menu = [
    {
        icon: 'Phone',
        label: 'Dial',
        link: '/admin/dial',
    },
    {
        icon: 'ChartSimple',
        label: 'Revenue',
        link: '/admin/revenue',
    },
    {
        icon: 'Building',
        label: 'Businesses',
        link: '/admin/businesses',
    },
    {
        icon: 'Vial',
        label: 'Experiments',
        link: '/admin/experiments',
    },
]

const Admin = () => {
    return <>
        <TopBar title="Admin" />
        <Page>
            <Sections>
                <Report />

                <ul className="divide-y divide-gray-200 rounded-xl border">
                    {menu.map((item, i) => (
                        <li key={i}>
                            <Link to={item.link} className="flex items-center justify-between gap-x-6 p-3">
                                <span className="flex align-middle">
                                    <Icon icon={item.icon} className="mr-2" />
                                    <span>{item.label}</span>
                                </span>
                                <span>
                                    <Icon size="2x" icon="RightChevron" />
                                </span>
                            </Link>
                        </li>
                    ))}
                </ul>

                <Notifications />
            </Sections>
        </Page>
    </>
}

export default Admin;
